{
  "es": {
    "employee": {
      "actions": {
        "accessProjects": "Gestionar acceso a proyectos",
        "cancel": "Deshacer",
        "changeProfilePicture": "Cambiar foto de perfil",
        "change_role": "Cambiar rol a",
        "download": "Descargar",
        "new": "Empleado",
        "profilePictureFormat": "Debe medir al menos 300x300px",
        "save": "Guardar",
        "searchEmployee": "Buscar empleado",
        "sendinvitation": "Crear y enviar invitación",
        "submit": "Guardar",
        "undoChanges": "Deshacer"
      },
      "attributes": {
        "email_address": "Correo electrónico",
        "email_notifications_interval": {
          "daily": "Una vez al día (alrededor del mediodía)",
          "hourly": "Cada hora",
          "twice_daily": "Dos veces al día (mañana/mediodía)",
          "weekly": "Una vez a la semana (lunes al mediodía)"
        },
        "first_name": "Nombre",
        "language": "Idioma",
        "last_name": "Apellidos",
        "phone_landline": "Número de teléfono fijo",
        "phone_mobile": "Número de móvil",
        "profession": "Cargo",
        "role": "Permisos de acceso",
        "signature_html": "Firma de la conversación",
        "status": "Estado",
        "title": "Tratamiento"
      },
      "integrations": {
        "hide_details": "Ocultar detalles",
        "last_synced_at": "Última sincronización: {time}",
        "show_details": "Mostrar detalles"
      },
      "labels": {
        "all_projects": "Todos los proyectos",
        "confirmChangeRoleTitle": "¿Cambiar el rol a {role}?",
        "confirmChangeRoleToMaintainer": "Nota: {name} perderá el acceso a todos los proyectos y se eliminarán todas las notificaciones existentes. Después podrás volver a asignar a {name} a proyectos como mantenedor.",
        "confirmChangeRoleToOwner": "{name} obtendrá acceso a todos los proyectos y a todo el contenido de la plataforma.",
        "confirmPasswordReset": "Se ha enviado un correo con un enlace para restablecer tu contraseña; revisa tu bandeja de entrada. Contáctanos si tienes algún problema.",
        "disabled": {
          "access": "Daremos acceso a la plataforma a todos los empleados en cuanto se pague la última factura vencida.",
          "contact": "Contáctanos",
          "overdue": "Hemos detectado que tu última factura lleva mucho tiempo vencida. Hemos revocado el acceso a todos los empleados de esta plataforma. Los colaboradores y clientes seguirán pudiendo acceder a sus datos.",
          "title": "¡Tu cuenta ha sido desactivada!"
        },
        "display": "Visualización",
        "filters": "Filtros",
        "generalNotifications": "Notificarme sobre",
        "has_access_to": "Tiene acceso a",
        "information": "Información del perfil",
        "informationNotificationsEmail": "Recibe una vista general por correo con las notificaciones que aún no has visto en la plataforma.",
        "informationNotificationsPlatform": "Recibe todas las notificaciones en tu vista general personal, en la parte superior derecha de la pantalla.",
        "informationNotificationsTitle": "Decide qué tipo de notificaciones quieres recibir y cómo",
        "its_you!": "¡Eres tú!",
        "last_login": "Último inicio de sesión",
        "maintainerAccess": "Requiere acceso por proyecto.",
        "name": "Nombre",
        "onPlatform": "En la plataforma",
        "ownerAccess": "Tiene acceso a todos los proyectos y contenidos de la plataforma de {client_name}.",
        "password": "Contraseña",
        "permissions": "Permisos de acceso para",
        "permissionsOwnerOnly": "Como mantenedor de proyecto no puedes realizar esta acción. Pide a un empleado de {client_name} con el rol de propietario que lo haga por ti.",
        "projectMaintains": "{first_name} tiene acceso a los siguientes proyectos:",
        "projectMaintainsAdd": "Para conceder acceso, selecciona un proyecto y añade a {first_name} como mantenedor de proyecto en la función Información.",
        "projectMaintainsNone": "no tiene acceso a ningún proyecto.",
        "projectNotifications": "Para el proyecto",
        "search_by_name_or_email": "Buscar por nombre o correo",
        "show_signature": "Mostrar firma",
        "signature_active": "Firma activa",
        "signature_info": "Esta firma se añadirá a las respuestas enviadas a clientes y colaboradores.",
        "sorting": "Orden",
        "viaEmail": "Por correo"
      },
      "modals": {
        "maintainers_access": {
          "accessible": "Accesible",
          "description": "Los cambios se guardan automáticamente",
          "not_accessible": "No accesible",
          "title": "Actualizar accesibilidad del proyecto para {first_name} {last_name}"
        }
      },
      "roles": {
        "maintainer": "Mantenedor",
        "owner": "Propietario"
      },
      "toasts": {
        "create": "Empleado creado",
        "update": "Empleado actualizado"
      },
      "validation": {
        "emailTaken": "Este correo ya se ha utilizado",
        "mustBeEmailAddress": "Se requiere un correo válido",
        "needFirstName": "El nombre es obligatorio",
        "needLastName": "Los apellidos son obligatorios",
        "requireEmailAddress": "El correo es obligatorio",
        "role": "Selecciona los permisos de acceso"
      }
    }
  }
}
